import { ProviderName } from 'v2/constants';
import { SelectOption } from 'v2/types';
import { identifyArrayToSelect } from 'v2/utils';

export const options: SelectOption<ProviderName>[] = identifyArrayToSelect([
  ProviderName.BGAMING,
  ProviderName.BELATRA,
  ProviderName.EVOPLAY,
  ProviderName.POPIPLAY,
  ProviderName.ONLYPLAY,
  ProviderName.JDB,
  ProviderName.TRUELAB,
  ProviderName.ONESPIN4WIN,
  ProviderName.FUGASO,
  ProviderName.GAMZIX,
  ProviderName.DYNABIT,
  ProviderName.AVIATRIX,
]);
